import {
  Typography,
  Grid,
  Box,
  Paper,
  Avatar,
} from '@mui/material';

import {
  AccessTime as AccessTimeIcon,
  CheckCircle as CheckCircleIcon,
  ElectricBolt as ElectricBoltIcon
} from '@mui/icons-material';

export const DevelopmentCard = ({
  title,
  type,
  date,
  completedDate,
  description,
  points,
  onClick,
  icon
}: {
  title: string;
  type: 'video' | 'document' | 'development';
  date: string;
  completedDate?: string;
  description: string;
  points: number;
  onClick?: () => void;
  icon?: React.ReactNode;
}) => (
  <Paper
    elevation={2}
    sx={{
      p: 2,
      mb: 2,
      borderLeft: '4px solid',
      borderColor: 'primary.main',
      transition: 'transform 0.2s',
    }}
  >
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1.5}>
          {icon && (
            <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
              {icon}
            </Avatar>
          )}
          <Typography
            variant="subtitle1"
            fontWeight={550}
            onClick={onClick}
            sx={{
              cursor: onClick ? 'pointer' : 'default',
              '&:hover': { textDecoration: onClick ? 'underline' : 'none' }
            }}
          >
            {title}
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <AccessTimeIcon fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            {type === 'development' ? 'Submitted' : 'Completed'}: {date}
          </Typography>
        </Box>
      </Grid>

      {completedDate && (
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircleIcon fontSize="small" sx={{ color: "#66bb6a" }} />
            <Typography variant="body2" color="text.secondary">
              Completed: {completedDate}
            </Typography>
          </Box>
        </Grid>
      )}

      <Grid item xs={12} mt={1} mb={1}>
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
        >
          {description}
        </Typography>
      </Grid>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          backgroundColor: '#f0f4f0',
          borderRadius: '8px',
          padding: '8px 16px',
          color: '#66bb6a',
          fontWeight: 'bold',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ElectricBoltIcon fontSize="small" sx={{ color: '#66bb6a' }} />
        <Typography variant="body2" fontWeight={600} ml={0.5} color="#66bb6a">
          {points} points
        </Typography>
      </Box>
    </Grid>
  </Paper>
);